import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from '../../styles/forms/form-row.module.css';

export interface FormRowProps {
    children?: ReactNode;
    alwaysHorizontal?: boolean;
    className?: string | null;
}

function FormRow({ children = null, alwaysHorizontal = false, className = null }: FormRowProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.alwaysHorizontal]: alwaysHorizontal,
                },
                className,
            ])}
        >
            {children}
        </div>
    );
}

export default FormRow;
